<template>
  <div>
    <v-stepper flat class="borderless shadowless" value="2">
      <v-stepper-header flat class="borderless shadowless">
        <v-stepper-step step="1" complete>Détails préliminaires</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2">Ajouter le responsable et l'organisateur de
          l'évènement</v-stepper-step>

        <v-divider></v-divider>

        <v-divider></v-divider>

        <!-- <v-divider></v-divider>

        <v-stepper-step step="4">Notification de rappel</v-stepper-step> -->
      </v-stepper-header>
    </v-stepper>
    <br />

    <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
      {{ snackbar_message }}
    </v-snackbar>

    <v-form @submit.prevent="newEvent2()">
      <v-card-title>
        <h6 class="primary--text">
          Saisir le nom du responsable de l'évènement
        </h6>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-layout wrap v-if="authUser">
            <v-flex xs12>
              <v-text-field v-model="authUser.full_name" label="Nom du responsable" clearable solo
                disabled></v-text-field>
        
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-text>
        <v-container>
          <v-layout wrap>
            <v-flex xs6 sm4>
              <v-subheader>Organisateur de l'évènement</v-subheader>
            </v-flex>
            <v-flex xs6 sm8>
              <v-radio-group v-model="select" inline>

                <v-radio v-for="org in organisator_types" :key="org.id" :label="org.name" :value="org"
                  color="primary"></v-radio>

                <!--  <v-radio label="Staff ACMA3" value="Staff ACMA3" color="primary"></v-radio>
                <v-radio label="SAE" value="SAE" color="primary"></v-radio> -->
              </v-radio-group>
            </v-flex>
            <v-flex xs6 sm4 v-if="select && select.name == 'SAE' && (role == 'super administrator'|| role == 'administrateur' || role == 'Moderator staff ACMA 3' || role == 'Staff ACMA'|| role == 'Jeune TIC')">
              <v-subheader>Type SAE {{ role }}</v-subheader>
            </v-flex>
            <v-flex xs6 sm8 v-if="select && select.name == 'SAE' && (role == 'super administrator'|| role == 'administrateur' || role == 'Moderator staff ACMA 3' || role == 'Staff ACMA'|| role == 'Jeune TIC')">
              <v-radio-group v-model="eventOne.sae_type_id" inline>
                <v-radio v-for="sae in sae_types" :key="sae.id" :label="sae.name" :value="sae.id"
                  color="primary"></v-radio>
              </v-radio-group>
            </v-flex>

            <v-flex xs6 sm4>
              <v-subheader>Nom du staff ACMA3 impliqué</v-subheader>
            </v-flex>
            <v-flex xs6 sm8>
              <v-text-field v-model="eventOne.staff_name" :rules="nameRules" label="Nom du staff ACMA3 impliqué"
                clearable solo></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <div class="text-center mt-5">
        <v-btn rounded color="info" @click="previousStep()" :disabled="loadingSave" class="mx-3">Précédent</v-btn>
        <v-btn rounded color="primary" :loading="loadingSave" :disabled="loadingSave" type="submit">Enregistrer</v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import Permissions from '~/mixins/Permissions'
export default {
  name: 'create-event-2',
  mixins: [Permissions],
  data() {
    return {
      // first_form_filled: this.$route.params.first_next,
      autoUpdate: true,
      select: null,
      isUpdating: false,
      snackbar: false,
      snackbar_message: '',
      snackbar_timeout: 5000,
      snackbar_color: '',
      loadingSave: false,
      nameRules: [v => !!v || 'Nom requis'],
      eventOne: {},
      role: '',

    }
  },

  created() {
    this.$checkPermission('create events')
    this.fetchUtils()
  },

  mounted() {
    this.checkRegistering()
  },

  computed: {
    profiles() {
      return this.$store.getters.getProfiles
    },
    sae_types() {
      return this.$store.getters.sae_types
    },
    organisator_types() { return this.$store.getters.organisator_types; },
    authUser() {
      return this.$store.getters.authUser
    }
  },

  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    }
  },

  methods: {
    async fetchUtils() {
      await this.$store.dispatch("fetchUser");
      this.$store.dispatch('fetchOrganisatorTypes')

      this.eventOne = JSON.parse(JSON.stringify(this.$store.getters.getNewEvent))
      const item = JSON.parse(
        JSON.stringify(this.$store.getters.authUser)
      );
      if (this.authUser && this.authUser.user && this.authUser.user.roles[0]) {
        this.role = this.authUser.user.roles[0].name
      }
      console.log({ authUser: this.authUser })

      if (item != null) {
        this.eventOne.user_ids = [item.user.id]
      }
      this.eventOne.event_organiser = this.$store.getters.getNewEvent.event_organiser
      this.eventOne.staff_name = this.$store.getters.getNewEvent.staff_name
      this.eventOne.sae_type_id = this.$store.getters.getNewEvent.sae_type_id
      const pays_id = this.$store.getters.getNewEvent.country_id
      await this.$store.dispatch('loadProfiles', pays_id)
      await this.$store.dispatch('fetchSaeTypes')

      if (this.eventOne.sae_type_id == null) { this.eventOne.sae_type_id = this.sae_types[0].id }
      if (this.eventOne.event_organiser != null) { this.select = this.eventOne.event_organiser }
    },

    checkRegistering() {
      var new_event = this.$store.getters.getNewEvent.user_ids
      if (new_event != null) {
        this.user_ids = new_event.user_ids
      }
    },

    remove(item) {
      const index = this.user_ids.indexOf(item.user_id)
      if (index >= 0) this.user_ids.splice(index, 1)
    },

    async newEvent2() {
      if (this.eventOne.user_ids && this.eventOne.user_ids.length > 0) {
        this.eventOne.event_organiser = this.select
        if (this.eventOne.event_organiser.slug !== "sae") {
          this.eventOne.sae_type_id = null
        }
        if (
          this.eventOne.event_organiser.slug == 'sae' &&
          this.eventOne.sae_type_id == ''
        ) {
          this.snackbar = true
          this.snackbar_color = 'error'
          this.snackbar_message =
            'Veuillez selectionner le type de SAE'
          return
        } else if (
          this.eventOne.event_organiser.slug == 'staff-acma-3' &&
          (this.eventOne.staff_name == '' ||
            this.eventOne.staff_name == null)
        ) {
          this.snackbar = true
          this.snackbar_color = 'error'
          this.snackbar_message =
            'Veuillez entrer le nom du staff ACMA3 impliqué'
          return
        } else {
          this.loadingSave = true;
          this.eventOne.organisator_type_id = this.select ? this.select.id : null
          // console.log( {'organisator_type': this.eventOne  } );
          this.$store.dispatch('storeEvent2', this.eventOne)
          // this.$router.push({ name: 'events.new-3' })

          // Save event first
          await this.$store.dispatch('createEvent').then(value => {
            this.loadingSave = false
            if (value === true) {
              const now = new Date();
              const start = new Date(this.eventOne.event_date);
              const end = new Date(this.eventOne.event_date_end);

              if (now >= start && now <= end) {
                this.$router.push({
                  name: "events.in_progress",
                  params: { event_updated: value }
                });
              }
              else if (now < end) {
                this.$router.push({
                  name: "events.coming",
                  params: { event_updated: value }
                });
              } else if (now > start) {
                this.$router.push({
                  name: "events.past",
                  params: { event_updated: value }
                });
              } else {
                this.$router.push({
                  name: "events.in_progress",
                  params: { event_updated: value }
                });
              }
            } else {
              console.log('Something went wrong!')
            }
          })
        }
      } else {
        this.snackbar = true
        this.snackbar_color = 'error'
        this.snackbar_message =
          'Veuillez choisir au moins un responsable'
        return
      }
    },

    previousStep() {
      this.$router.push({
        name: 'events.new' /*, params: { previous: true }*/
      })
    }
  }
}
</script>

<style scoped>
.theme--light.v-subheader {
  font-size: 1.3em;
  color: black;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/events/create-2.vue